import React from "react";

const PresedentMessage = () => {
  return (
    <div>
      <div className="container Allpagemargin mb-5">
        <div
          style={{
            boxShadow: "0px 0px 37px 0px lightgray",
            lineHeight: "30px",
            letterSpacing: "1px",
          }}
          className="p-5"
        >
          <h2 style={{ color: "#00C851" }} className="mb-5">
            MESSAGE FROM THE PRESIDENT DESK
          </h2>
          <p>
            We would like to express our gratitude to our advisors, members, and
            everyone who has responded to us from various places. We also want
            to take this opportunity to mention that, as an NGO, we have been
            addressing socially traumatic issues from the grassroots level
            through various activities over the past few years. Our objective is
            to foster a more civilized society ideally.
          </p>
          <p>
            Our focus areas for awareness are primarily schools and colleges, as
            they nurture the future citizens of India. Schools lay the
            foundation for every individual's life, and if the right moral
            values are instilled at this level, it is rare for a person to
            forget them throughout their life. We aim to make an impact on all
            children about these issues with the help of honorable teachers.
          </p>
          <p>
            We are pleased to share that people are willing to join hands for
            the noble causes we have raised, but many avoid initiatives due to
            their busy schedules. Therefore, we would like to invite every
            citizen of India and the world who is willing to raise awareness
            about these issues. Join us according to your availability and
            participate either physically, mentally, or financially.
          </p>
          <p>
            In our society, everyone contributes in their own way. Often, we
            unintentionally affect our environment. If someone makes us aware of
            such issues and their ill-effects, we can start avoiding them.
          </p>
          <p>
          Now is the time for everyone to think and come forward for:
          </p>
          <ul style={{color:'gray'}}>
            <li style={{listStyle:'disc'}}>Environmental Global Warming</li>
            <li style={{listStyle:'disc'}}>
            Making medical facilities more accessible, despite timely premium payments
            </li>
            <li style={{listStyle:'disc'}}>
            Combating computer illiteracy in the young generation, especially among students from poor backgrounds who cannot afford quality education

            </li>

            <li style={{listStyle:'disc'}}>
            Addressing traffic nuisances and jams, which cause pollution without valid reasons
            </li>
            <li style={{listStyle:'disc'}}> Promoting health awareness</li>
            <li style={{listStyle:'disc'}}>
            Spreading awareness about rights and responsibilities for our society and governing bodies (both private and government) to act wisely in the best interest of the common people.
            </li>
          </ul>
          <p>
            We need to aware everyone about their rights and responsibilities
            for our society and governing bodies (either private / government)
            to act smartly in the goodwill of common men.
          </p>
          <p>
          With these and many other themes, we have initiated this team and aim for a clean, green, healthy, literate, and more aware society.

          </p>
          <p style={{ color: "#00C851" }}>THINK GLOBALLY !!</p>
          <p>Best Wishes,</p>
          <p>
            <b>Vivek Vashistha</b>
          </p>
          <p>
            <b>President</b>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PresedentMessage;
